import { InsuranceRcaControls } from '../InsuranceRcaControls'
import { useGreenCardInsuranceValues } from './GreenCardInsuranceContext'
import { GreenCardFormValues } from './types'
import {
  formProps,
  normalizeOrderData,
  removeGreenCardValuesFromStorage
} from './utils'

type Props = {
  steps: number
  onReadyToSaveData?: () => void
}

export const GreenCardInsuranceControls = ({
  steps,
  onReadyToSaveData
}: Props) => {
  const { handleCalculate, isCalculatingLoading } =
    useGreenCardInsuranceValues()
  const { orderKey } = formProps()

  return (
    <InsuranceRcaControls
      steps={steps}
      onReadyToSaveData={onReadyToSaveData}
      removeFromStorage={removeGreenCardValuesFromStorage}
      handleCalculate={handleCalculate}
      isCalculatingLoading={isCalculatingLoading}
      errorUnwrapKeys={['green_card']}
      normalizeOrderData={(values) => ({
        id: values[orderKey.name] as number,
        requestBody: {
          green_card: normalizeOrderData(values as GreenCardFormValues)
        }
      })}
    />
  )
}
